import IconButton from "@mui/material/IconButton";
import { SxProps } from "@mui/material/styles";
import { useTranslation } from "next-i18next";
import { IconClose } from "src/components/icons-mui/close";

interface IMobileSearchFilterCloseButtonProps {
    onClose: () => void;
    sx?: SxProps;
}

export const MobileSearchFilterCloseButton = ({ onClose, sx }: IMobileSearchFilterCloseButtonProps) => {
    const { t } = useTranslation("common");

    return (
        <IconButton
            aria-label={t("close")}
            onClick={onClose}
            sx={{
                width: "40px",
                height: "40px",
                color: "gray.800",
                background: "transparent",
                boxShadow: "none",
                padding: 0,
                "&:hover, &:focus, &:active": {
                    backgroundColor: "gray.50",
                    color: "gray.800",
                },
                ...sx,
            }}
            size="large"
        >
            <IconClose sx={{ fontSize: 18 }} />
        </IconButton>
    );
};
